module.exports = __webpack_public_path__ + "static/img/one.0ac4976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/4/one.png
// module id = Sz4P
// module chunks = 1